var map = {
	"./Alaska_Denali.jpg": "27c9",
	"./Canada1.jpg": "ed49",
	"./IMG_9094.jpg": "3e70",
	"./NYC.jpg": "07ad",
	"./San_fran_bridge.jpg": "be5e",
	"./XiTang2.jpg": "7964",
	"./alaska_bears.jpg": "3ca8",
	"./amsterdam2.jpg": "3e86",
	"./atlanta_ga.jpg": "6ff4",
	"./bermuda1.jpg": "3d85",
	"./bermuda2.jpg": "8071",
	"./bermuda3.jpg": "8d9b",
	"./bermuda_statue.jpg": "c89d",
	"./boston1.jpg": "3cfa",
	"./bostonma.jpg": "bd2e",
	"./bostonma2.jpg": "3b5e",
	"./canda2.jpg": "ad7a",
	"./china.jpg": "fb47",
	"./china_wedding.jpg": "c62f",
	"./ed_sheeran.jpg": "22fc",
	"./fancy_charles.jpg": "35e1",
	"./fancy_charles2.jpg": "11c3",
	"./fenway1.jpg": "d844",
	"./forbidden_city1.jpg": "ae9d",
	"./greatwall.jpg": "662f",
	"./key_west1.jpg": "88c2",
	"./key_west2.jpg": "bc5b",
	"./lowell.jpg": "75f8",
	"./mckinley.jpg": "49a1",
	"./mutianyu2.jpg": "91d5",
	"./nantucket.jpg": "8c39",
	"./new_orleans1.jpg": "37f0",
	"./new_orleans2.jpg": "91ff",
	"./niagra_falls.jpg": "c57e",
	"./patriots.jpg": "3232",
	"./penn_state.jpg": "be4e",
	"./pittsburgh1.jpg": "da66",
	"./pittsburgh2.jpg": "23df",
	"./quebec_city.jpg": "e912",
	"./redsox2.jpg": "398e",
	"./san_fran_fisherman.jpg": "1d3e",
	"./seaward_alaska.jpg": "e09f",
	"./sf_steps.jpg": "b309",
	"./skydiving.jpg": "1abb",
	"./somerville_dog_fest.jpg": "04a5",
	"./south_boston.jpg": "a367",
	"./xian_terracotta_army.jpg": "0b85",
	"./xian_wall.jpg": "1e4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13df";